export const copyright = "© 2026 Cedrus Dang";